import { render, staticRenderFns } from "./booking_detail.vue?vue&type=template&id=649cdee6&scoped=true"
import script from "./booking_detail.vue?vue&type=script&lang=js"
export * from "./booking_detail.vue?vue&type=script&lang=js"
import style0 from "./booking_detail.vue?vue&type=style&index=0&id=649cdee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649cdee6",
  null
  
)

export default component.exports